import { useEffect, useState } from 'react';
import { useAuth } from '../../../context/auth-context.jsx';
import { adminApi } from '../../../lib/admin-api/index.js';
import { mapProfileStatsResponseToDto } from '../dto/profile-stats.dto.js';
import { buildProfileStatsCardsModel } from '../model/profile-stats-cards.model.js';

export function useDashboardProfileStats() {
  const { token } = useAuth();
  const [cards, setCards] = useState(() => buildProfileStatsCardsModel({}));
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let isCancelled = false;

    const loadStats = async () => {
      setIsLoading(true);
      setError('');

      try {
        const response = await adminApi.requestWithAuth({
          token,
          method: 'GET',
          path: '/admin/reports/stat/profiles',
        });

        if (!isCancelled) {
          const dto = mapProfileStatsResponseToDto(response);
          setCards(buildProfileStatsCardsModel(dto));
        }
      } catch (requestError) {
        if (!isCancelled) {
          setCards(buildProfileStatsCardsModel({}));
          setError(requestError?.message || 'Failed to load profile statistics');
        }
      } finally {
        if (!isCancelled) {
          setIsLoading(false);
        }
      }
    };

    loadStats();

    return () => {
      isCancelled = true;
    };
  }, [token]);

  return {
    cards,
    isLoading,
    error,
  };
}
